var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uiBlockedRemotely)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"blocker"},[_c('div',{staticClass:"blocker-inner"},[_vm._v(_vm._s(_vm.$t('remoteControlBlockerInfo')))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }